import React, { useContext } from 'react'
import { observer } from 'mobx-react'
import { setItemToArrayByIndex } from '@App/helpers/work-entities/removers'
import { publisherNameInvalidCheck } from '@App/helpers/work-entities/fields-validators'
import { StoresContext } from '@App/contexts'
import { WorkModel } from '@Entities/work/work'
import RootStore from '@App/stores/root-store'
import { PublisherSideBarState } from '@App/enum/publisher-side-bar-state'
import EditSimplePublisher from '@Components/WorkRegistrationSubs/EditSimplePublisher'
import { PublisherModel } from '@Entities/work/publisher-model'
import { OriginalPublisherModel } from '@Entities/work/original-publisher-model'

const EditSimpleOriginalPublisher = () => {
    const { publisherStepStore, workStore, popupStore } = useContext<RootStore>(StoresContext)

    const editingOP = publisherStepStore.editingOP

    const editOriginalPublisher = (publisher: PublisherModel) => {
        const workDraftFromLocal = workStore.workDraftLocal
        const editingOPId = editingOP.localId

        if (!workDraftFromLocal || !editingOPId) {
            return
        }

        const originalPublishers = workDraftFromLocal.originalPublishers
        const indexOfOP = originalPublishers.map((op: OriginalPublisherModel) => op.localId).indexOf(editingOPId)
        const updatedOriginalPublisher: OriginalPublisherModel = {
            localId: editingOPId,
            publisherName: publisher.publisherName,
            ipiNumber: publisher.ipiNumber ? publisher.ipiNumber.padStart(11, '0') : null,
            publisherShare: editingOP.publisherShare,
            administratorPublishers: editingOP.administratorPublishers,
            writers: editingOP.writers,
        }

        const updatedOPArray = setItemToArrayByIndex(originalPublishers, +indexOfOP, updatedOriginalPublisher)

        const updatedWorkDraft: WorkModel = {
            ...workDraftFromLocal,
            originalPublishers: updatedOPArray,
        }

        workStore.setWorkDraftToLocal(updatedWorkDraft)
        popupStore.setPublisherSidebarState(PublisherSideBarState.empty)
    }

    const validatePublisherName = (name: string) =>
        publisherNameInvalidCheck(name) ? 'Max length 200 symbol. May not include multiple lines.' : ''

    return (
        <EditSimplePublisher
            publisher={editingOP}
            title="Edit Original Publisher"
            subtitle="Enter the Publisher's details"
            editButtonText="Edit Publisher"
            publisherNameText="Publisher Name"
            validatePublisherName={validatePublisherName}
            returnPublisher={editOriginalPublisher}
        />
    )
}

export default observer(EditSimpleOriginalPublisher)
